export default "__VITE_ASSET__b15bc2b5__"